import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import TagManager from 'react-gtm-module';
import messages_en from './translations/en.json';
import Projects from './project/Projects';
import AdminPage from './admin/AdminPage';
import Layout from './shared/components/Layout';

const AuthenticatedApp: React.FC = () => {
  const [locale, setLocale] = useState(navigator.language || 'en-US');
  
  useEffect(() => {
    initializeAppSettings();
  }, []);

  const initializeAppSettings = async () => {
    try {
      const gtmResponse = await fetch("/api/settings/gtm-container-id");
      if (gtmResponse.ok) {
        const gtmContainerId = await gtmResponse.text();
        if (gtmContainerId) {
          TagManager.initialize({ gtmId: gtmContainerId });
        }
      }

      const regionResponse = await fetch("/api/settings/user-region");
      if (regionResponse.ok) {
        const userRegion = await regionResponse.json();
        if (userRegion?.cultureCode) {
          setLocale(userRegion.cultureCode);
        }
      }
    } catch (error) {
      console.error("Failed to initialize app settings:", error);
    }
  };

  const translations = new Map<string, any>([["en", messages_en]]);

  return (
    <IntlProvider messages={translations.get("en")} locale={locale}>
      <Routes>
        <Route path="admin" element={<AdminPage />} />
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route path="projects/*" element={<Projects />} />
              <Route path="*" element={<Navigate replace to="/projects" />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </IntlProvider>
  );
};

export default AuthenticatedApp;